import { render } from "./NFT.vue?vue&type=template&id=5496f3da&scoped=true"
import script from "./NFT.vue?vue&type=script&lang=js"
export * from "./NFT.vue?vue&type=script&lang=js"

import "./NFT.vue?vue&type=style&index=0&id=5496f3da&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prd-cce-chain-browser-static-nft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5496f3da"]])

export default __exports__